export const ACTIVITY_LOG = 'activity-log'
export const PROGRESS_HISTORY = 'progress-history'
